module.exports = __webpack_public_path__ + "static/media/Users.349fe064.png";